export default "__VITE_ASSET__BjEoKujV__"